// extracted by mini-css-extract-plugin
export default {"forbidden":"Forbidden_forbidden__fDZag","lock":"Forbidden_lock__4FTi8","dip":"Forbidden_dip__fHQ59","spin":"Forbidden_spin__HrMxl"};